module.exports = __webpack_public_path__ + "img/opensea.def0051d.svg";